import React from 'react';
import { WebImage } from 'components/common/WebImage';
import { WebImageProps } from 'types/webImageProps';
import { Wrapper } from './atoms/Wrapper';

export interface ImageGalleryProps {
    images: Array<WebImageProps>;
}
export const ImageGallery: React.FC<ImageGalleryProps> = ({ images }) => (
    <Wrapper>
        {images.map((image) => (
            <div key={image.id}>
                <WebImage image={image} />
            </div>
        ))}
    </Wrapper>
);
